import { useEffect, useState } from 'react';

export function useVisibleHeight(ref: React.RefObject<HTMLElement>) {
  const [visibleHeight, setVisibleHeight] = useState<number>(0);

  useEffect(() => {
    const updateHeight = () => {
      if (!ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.top;
      setVisibleHeight(spaceBelow);
    };

    updateHeight();
    window.addEventListener('resize', updateHeight);
    window.addEventListener('scroll', updateHeight);

    return () => {
      window.removeEventListener('resize', updateHeight);
      window.removeEventListener('scroll', updateHeight);
    };
  }, [ref]);

  return visibleHeight;
}
